import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Clio admin module — `/clio` on console.francisquini.ai.
 *
 * Dashboard for audit-log inspection + LGPD pipeline + retention policy
 * editor. Backed by the Clio admin endpoints at
 * `runtime-config.api.clio` (`POST/GET /v1/admin/*`).
 *
 * Surface is `'admin'` — registered only on the console host. Each page
 * also wraps `<RequireAdmin>` for defence-in-depth.
 *
 * Spec: `docs/cockpit/dashboards/tier-4-admin-baixa-frequencia.md` §4.1.
 */
export const manifest: ModuleManifest = {
  module_id: 'clio',
  display_name: 'Clio',
  surface: 'admin',
  routes: [
    {
      path: '/clio',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioHomePage,
        })),
      title: 'Clio — Audit log',
      permissions: [],
    },
    {
      path: '/clio/events',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioEventsPage,
        })),
      title: 'Clio — Events',
      permissions: [],
    },
    {
      path: '/clio/events/$id',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioEventDetailPage,
        })),
      title: 'Clio — Event detail',
      permissions: [],
    },
    {
      path: '/clio/users/$userId',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioUserAuditPage,
        })),
      title: 'Clio — Audit por usuário',
      permissions: [],
    },
    {
      path: '/clio/lgpd',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioLgpdPage,
        })),
      title: 'Clio — LGPD pipeline',
      permissions: [],
    },
    {
      path: '/clio/lgpd/$jobId',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioLgpdJobDetailPage,
        })),
      title: 'Clio — Job LGPD',
      permissions: [],
    },
    {
      path: '/clio/retention',
      component: () =>
        import('@/routes/_app/clio').then((m) => ({
          default: m.ClioRetentionPage,
        })),
      title: 'Clio — Retenção',
      permissions: [],
    },
  ],
}
